import { isEmoji } from '../../../utils/isEmoji';
/**
 * Возвращает буквы из имени
 *
 * @param {string} title
 * @return {string}
 */

export var getAvatarText = function getAvatarText(title) {
  if (title && title.length) {
    var trimmedTitleArray = title.trim().split(' ');
    var titleArray = trimmedTitleArray.filter(function (item) {
      return !isEmoji(item);
    });

    if (titleArray.length === 1) {
      return titleArray[0][0];
    } else if (titleArray.length > 1) {
      return "".concat(titleArray[0][0]).concat(titleArray[1][0]);
    }
  }

  return '#';
};